import { render, staticRenderFns } from "./UseDetail.vue?vue&type=template&id=fa244b9a&"
import script from "./UseDetail.vue?vue&type=script&lang=js&"
export * from "./UseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports